import { useEffect, useRef } from "react";
import { Bold, Italic, List, ListOrdered, Link2, Heading2, Quote } from "lucide-react";

export default function RichText({ value, onChange, testid }) {
  const ref = useRef(null);
  const mounted = useRef(false);
  useEffect(() => {
    if (!mounted.current && ref.current) {
      ref.current.innerHTML = value || "";
      mounted.current = true;
    }
  }, [value]);
  useEffect(() => {
    mounted.current = false;
    if (ref.current) ref.current.innerHTML = value || "";
    mounted.current = true;
  }, [testid]);

  const exec = (cmd, arg = null) => {
    ref.current.focus();
    document.execCommand(cmd, false, arg);
    onChange(ref.current.innerHTML);
  };
  const btn = "p-2 rounded-lg hover:bg-ngo-mint text-ngo-deep transition-colors duration-150";

  return (
    <div className="rounded-xl border border-ngo-deep/20 bg-white overflow-hidden">
      <div className="flex flex-wrap gap-1 border-b border-ngo-deep/10 px-2 py-1.5 bg-ngo-cream/70">
        <button type="button" className={btn} onClick={() => exec("bold")} aria-label="बोल्ड" data-testid={`${testid}-bold`}><Bold size={15} /></button>
        <button type="button" className={btn} onClick={() => exec("italic")} aria-label="इटैलिक"><Italic size={15} /></button>
        <button type="button" className={btn} onClick={() => exec("formatBlock", "<h3>")} aria-label="शीर्षक"><Heading2 size={15} /></button>
        <button type="button" className={btn} onClick={() => exec("formatBlock", "<blockquote>")} aria-label="उद्धरण"><Quote size={15} /></button>
        <button type="button" className={btn} onClick={() => exec("insertUnorderedList")} aria-label="सूची"><List size={15} /></button>
        <button type="button" className={btn} onClick={() => exec("insertOrderedList")} aria-label="क्रमित सूची"><ListOrdered size={15} /></button>
        <button type="button" className={btn} onClick={() => { const u = window.prompt("लिंक URL"); if (u) exec("createLink", u); }} aria-label="लिंक"><Link2 size={15} /></button>
      </div>
      <div
        ref={ref}
        data-testid={testid}
        contentEditable
        suppressContentEditableWarning
        onInput={() => onChange(ref.current.innerHTML)}
        className="min-h-[240px] px-4 py-3 text-sm leading-relaxed text-ngo-ink focus:outline-none"
        style={{ wordBreak: "break-word" }}
      />
    </div>
  );
}
